import { render, staticRenderFns } from "./AddressOption.vue?vue&type=template&id=60e86e9b&scoped=true&"
import script from "./AddressOption.vue?vue&type=script&lang=js&"
export * from "./AddressOption.vue?vue&type=script&lang=js&"
import style0 from "./AddressOption.vue?vue&type=style&index=0&id=60e86e9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e86e9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRadio,VRadioGroup,VSwitch,VTextField})
